import { Link } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const Homepage = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const partners = [
    { name: "Amazon SPN", logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" },
    { name: "Flipkart SPN", logo: "https://static-assets-web.flixcart.com/batman-returns/batman-returns/p/images/fkheaderlogo_exploreplus-def50f.svg" },
    { name: "Microsoft AI", logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg" },
    { name: "SAP Partner", logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg" }
  ];

  return (
    <div style={{ backgroundColor: "#020617", color: "#f8fafc", fontFamily: "'Inter', sans-serif", margin: 0 }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');
        html { scroll-behavior: smooth; }
        .nav-link { color: #94a3b8; text-decoration: none; font-size: 13px; font-weight: 700; letter-spacing: 1px; transition: 0.3s; cursor: pointer; }
        .nav-link:hover { color: #3b82f6; }
        .glass-panel { background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.08); padding: 50px; border-radius: 12px; transition: 0.3s; }
        .glass-panel:hover { border-color: #3b82f6; transform: translateY(-5px); background: rgba(59, 130, 246, 0.04); }
        .accent { color: #3b82f6; }
        .btn-main { background: #3b82f6; color: white; border: none; font-size: 18px; padding: 22px 60px; font-weight: 900; letter-spacing: 2px; cursor: pointer; clip-path: polygon(10% 0, 100% 0, 90% 100%, 0% 100%); transition: 0.3s; }
        .btn-main:hover { transform: scale(1.05); box-shadow: 0 0 20px rgba(59, 130, 246, 0.4); }
        .section-label { font-size: 12px; font-weight: 900; letter-spacing: 4px; color: #3b82f6; text-transform: uppercase; margin-bottom: 20px; display: block; }
      `}</style>

{/* 1. DYNAMIC NAVBAR - UPSCALED LOGO */}
      <nav style={{
    position: "fixed", 
    top: 0, 
    width: "100%", 
    zIndex: 1000, 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center",
    padding: scrolled ? "12px 80px" : "25px 80px", 
    transition: "0.4s ease-in-out",
    background: scrolled ? "#ffffff" : "transparent",
    borderBottom: scrolled ? "1px solid #e2e8f0" : "none",
    boxSizing: "border-box"
}}>
  <style>{`
    .nav-item {
      position: relative;
      padding: 15px 0;
    }

    /* MEGA MENU CONTAINER */
    .mega-menu {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%) translateY(20px);
      background: ${scrolled ? "#ffffff" : "#0f172a"};
      width: 900px; /* Wide format like Yash */
      display: grid;
      grid-template-columns: repeat(4, 1fr); /* 4 Columns of Titles */
      gap: 30px;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 30px 60px rgba(0,0,0,0.2);
      opacity: 0;
      visibility: hidden;
      transition: 0.4s cubic-bezier(0.23, 1, 0.32, 1);
      border: 1px solid ${scrolled ? "#e2e8f0" : "rgba(255,255,255,0.1)"};
    }

    .nav-item:hover .mega-menu {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(5px);
    }

    /* TITLE STYLING */
    .menu-title {
      font-size: 13px;
      font-weight: 800;
      color: ${scrolled ? "#0f172a" : "#f3f9f0"};
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 15px;
      border-bottom: 1px solid ${scrolled ? "#f1f5f9" : "rgba(255,255,255,0.1)"};
      padding-bottom: 8px;
    }

    /* SUB-SERVICE LINKS */
    .menu-link {
      display: block;
      padding: 6px 0;
      color: ${scrolled ? "#64748b" : "#cbd5e1"};
      text-decoration: none;
      font-size: 13px;
      font-weight: 500;
      transition: 0.2s;
    }
    .menu-link:hover {
      color: #3b82f6 !important;
      padding-left: 5px;
    }
    
    /* MEGA MENU CONTAINER */
    .mega-menu2 {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%) translateY(20px);
      background: ${scrolled ? "#ffffff" : "#0f172a"};
      width: auto; /* Wide format like Yash */
      display: grid;
      grid-template-columns: repeat(4, 1fr); /* 4 Columns of Titles */
      gap: 30px;
      padding: 10px;
      border-radius: 8px;
      box-shadow: 0 30px 60px rgba(0,0,0,0.2);
      opacity: 0;
      visibility: hidden;
      transition: 0.4s cubic-bezier(0.23, 1, 0.32, 1);
      border: 1px solid ${scrolled ? "#e2e8f0" : "rgba(255,255,255,0.1)"};
    }

    .nav-item:hover .mega-menu2 {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(5px);
    }

    /* TITLE STYLING */
    .menu-title {
      font-size: 13px;
      font-weight: 800;
      color: ${scrolled ? "#0f172a" : "#f3f9f0"};
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 15px;
      border-bottom: 1px solid ${scrolled ? "#f1f5f9" : "rgba(255,255,255,0.1)"};
      padding-bottom: 8px;
    }

    /* SUB-SERVICE LINKS */
    .menu-link {
      display: block;
      padding: 6px 0;
      color: ${scrolled ? "#64748b" : "#cbd5e1"};
      text-decoration: none;
      font-size: 13px;
      font-weight: 500;
      transition: 0.2s;
    }
    .menu-link:hover {
      color: #3b82f6 !important;
      padding-left: 5px;
    }
  `}</style>

  

  {/* LOGO AREA - Same as your script */}
  <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
    <img src="/logo.png" alt="Promicon" style={{ height: scrolled ? "38px" : "52px", transition: "0.4s", filter: scrolled ? "none" : "brightness(0) invert(1)" }} />
    <div style={{ fontSize: scrolled ? "22px" : "28px", fontWeight: "900", color: scrolled ? "#0f172a" : "#ffffff", letterSpacing: "-1.5px" }}>PROMICON</div>
  </div>

  {/* LINKS AREA */}
  <div style={{ display: "flex", gap: "45px", alignItems: "center" }}>
    
    {/* SERVICES MEGA MENU 1*/}
    <div className="nav-item">
      <a href="#Services" style={{ color: scrolled ? "#475569" : "#ffffff", textDecoration: "none", fontSize: "14px", fontWeight: "700" }}>SERVICES</a>
      
      <div className="mega-menu">
        {/* Column 1 */}
        <div>
          <div className="menu-title">Ecommerce Management</div>
          <Link to="/EnterpriseSolutions/Amazonaccountmanagement" className="menu-link">Amazon Account Management</Link>
          <Link to="/EnterpriseSolutions/Flipkartaccountmanagement" className="menu-link">Flipkart Account Management</Link>
          <Link to="/EnterpriseSolutions/Meeshoaccountmanagement" className="menu-link">Meesho Account Management</Link>
          <Link to="/EnterpriseSolutions/Brand-Registry" className="menu-link">Brand Registry & Account Setup</Link>
        </div>

        {/* Column 2 */}
        <div>
          <div className="menu-title">Listing and Cataloging</div>
          <Link to="/ListingandCataloging/Amazon-Listing" className="menu-link">Amazon Product Listing</Link>
          <Link to="/ListingandCataloging/Flipkart-Listing" className="menu-link">Flipkart Product Listing</Link>
          <Link to="/ListingandCataloging/Meesho-Listing" className="menu-link">Meesho Product Listing</Link>
          <Link to="/ListingandCataloging/Meesho-Listing" className="menu-link">Shopsy Product Listing</Link>
          <Link to="/ListingandCataloging/Catalog-Optimization" className="menu-link">Catalog Optimization</Link>
          <Link to="/ListingandCataloging/ListingSEO-ContentEnhancement " className="menu-link">Listing SEO & Content Enhancement</Link>
        </div>

        {/* Column 3 */}
        <div>
          <div className="menu-title">Ecommerce Advertising</div>
          <Link to="/EcommerceAdvertsing/Amazon-advertising" className="menu-link">Amazon PPC Management</Link>
          <Link to="/EcommerceAdvertsing/Flipkart-advertising" className="menu-link">Flipkart Ads Management</Link>
          <Link to="/EcommerceAdvertsing/Meta-advertising" className="menu-link">Meta ads Optimization</Link>
        </div>

        {/* Column 4 */}
        <div>
          <div className="menu-title">Branding and Content</div>
          <Link to="/BrandingandContent/Aplus-Content" className="menu-link">Amazon A+ Content</Link>
          <Link to="/BrandingandContent/Flipkart-RPD" className="menu-link">Flipkart RPD</Link>
          <Link to="/BrandingandContent/Infographics" className="menu-link">Infographics</Link>
          <Link to="/BrandingandContent/Store-front" className="menu-link">Amazon Store Front</Link>
          <Link to="/BrandingandContent/AmazonBrand-Story" className="menu-link">Amazon Brand Story</Link>
        </div>

        {/* Row 2 - Column 1 */}
        <div style={{marginTop: "20px"}}>
          <div className="menu-title">Enterprise Solutions</div>
          <Link to="/EnterpriseSolutions/Financial-Systems" className="menu-link">Financial Systems Management</Link>
          <Link to="/EnterpriseSolutions/Enterprise-Implementation" className="menu-link">Enterprise System Implementation</Link>
          <Link to="/EnterpriseSolutions/Businessprocess-Optimization" className="menu-link">Business Process Optimization</Link>
          <Link to="/EnterpriseSolutions/Enterprise-Integration" className="menu-link">Enterprise Integration & Automation</Link>
        </div>

        {/* Row 2 - Column 2 */}
        <div style={{marginTop: "20px"}}>
          <div className="menu-title">Productivity & Intelligence</div>
          <Link to="/ProductivityandIntelligence/Productivity-Solutions" className="menu-link">Business Productivity Solutions</Link>
          <Link to="/ProductivityandIntelligence/Applications-CRM" className="menu-link">Business Applications & CRM</Link>
          <Link to="/ProductivityandIntelligence/Reporting-Automation" className="menu-link">Data, Reporting & Automation</Link>
          <Link to="/ProductivityandIntelligence/Cloud-Support" className="menu-link">Cloud & Infrastructure Support</Link>
        </div>
      </div>
    </div>
    {/* SERVICES MEGA MENU 2*/}
    <div className="nav-item">
      <a href="#PARTNERS" style={{ color: scrolled ? "#475569" : "#ffffff", textDecoration: "none", fontSize: "14px", fontWeight: "700" }}>PARTNERS</a>
      
      <div className="mega-menu">
        {/* Column 1 */}
        <div>
          <div className="menu-title">Amazon</div>
          <Link to="/Parterns/Amazon/AmazonRegistration-Launch" className="menu-link">Account Registration and Launch</Link>
          <Link to="/Parterns/Amazon/Amazon-management" className="menu-link">Account Management</Link>
          <Link to="/Parterns/Amazon/Amazonlisting-cataloging" className="menu-link">Listing and Cataloging</Link>
          <Link to="/Parterns/Amazon/Amazon-Campaignmanager" className="menu-link">Advertising</Link>
          <Link to="/Parterns/Amazon/Amazon-Reinstatement" className="menu-link">Account Reinstatement</Link>
          <Link to="/Parterns/Amazon/Aplus-info" className="menu-link">A+ Content & Infographics</Link>
          <Link to="/Parterns/Amazon/Storefront" className="menu-link">Storefront</Link>
        </div>

        {/* Column 2 */}
        <div>
          <div className="menu-title">Flipkart</div>
          <Link to="/Parterns/Flipkart/FlipkartAccount-Creation" className="menu-link">Account creation and launch</Link>
          <Link to="/Parterns/Flipkart/FlipkartAccount-Management" className="menu-link">Account Management</Link>
          <Link to="/Parterns/Flipkart/FlipkartAccount-Advertising" className="menu-link">Advertising</Link>
          <Link to="/Parterns/Flipkart/FlipkartAccount-RPD" className="menu-link">Flipkart RPD</Link>
        </div>

        {/* Column 3 */}
        <div>
          <div className="menu-title">Meesho</div>
          <Link to="/Parterns/Meesho/MSAccountCreationlaunch" className="menu-link">Account Creation and launch</Link>
          <Link to="/Parterns/Meesho/MSAccount-Management" className="menu-link">Account Management</Link>
          <Link to="/Parterns/Meesho/MS-Advertising" className="menu-link">Advertising</Link>
        </div>

        {/* Column 4 */}
        <div>
          <div className="menu-title">SAP</div>
          <Link to="/Parterns/SAP/SAP-FICO" className="menu-link">SAP FICO</Link>
          <Link to="/Parterns/SAP/SAP-BTP" className="menu-link">SAP BTP</Link>
          <Link to="/Parterns/SAP/Rise-with-SAP" className="menu-link">Rise with SAP</Link>
          <Link to="/Parterns/SAP/SAP-S4HANA" className="menu-link">SAP S/4HANA</Link>
          <Link to="/Parterns/SAP/SAP-Support" className="menu-link">SAP Support</Link>
        </div>

        {/* Row 2 - Column 1 */}
        <div style={{marginTop: "20px"}}>
          <div className="menu-title">Microsoft</div>
          <Link to="/Parterns/Microsoft/Microsoft-365" className="menu-link">Microsoft 365</Link>
          <Link to="/Parterns/Microsoft/Dynamic-Solutions" className="menu-link">Dynamics Business Solutions</Link>
          <Link to="/Parterns/Microsoft/Microsoft-Cloud-Platform" className="menu-link">Microsoft Cloud Platform</Link>
          <Link to="/Parterns/Microsoft/Microsoft-SupportServices" className="menu-link">Microsoft Support Services</Link>
        </div>

        {/* Row 2 - Column 2 */}
        <div style={{marginTop: "20px"}}>
          <div className="menu-title">Meta</div>
          <Link to="/Parterns/Meta/Meta-advertising" className="menu-link">Advertising</Link>
          <Link to="/Parterns/Meta/Audience-Targeting-Strategy" className="menu-link">Audience Targeting & Strategy</Link>
          <Link to="/Parterns/Meta/CreativeAd-Optimization" className="menu-link">Creative & Ad Optimization</Link>
          <Link to="/Parterns/Meta/Tracking-Performance-Analytics" className="menu-link">Tracking & Performance Analytics</Link>
        </div>
      </div>
    </div> 

    {/* SERVICES MEGA MENU 3*/}
    <div className="nav-item">
      <a  style={{ color: scrolled ? "#475569" : "#ffffff", textDecoration: "none", fontSize: "14px", fontWeight: "700" }}>ABOUT US</a>
      <div className="mega-menu2">
        {/* Column 1 */}
        <div>
          <div className="menu-title">About Us</div>
          <Link to="/about-us" className="menu-link">About Promicon</Link>
          <Link to="/Blogs" className="menu-link">Blogs</Link>
          
        </div>
      </div>
      
    </div>
    {/* SERVICES MEGA MENU 4*/}
    <div className="nav-item">
      <a  style={{ color: scrolled ? "#475569" : "#ffffff", textDecoration: "none", fontSize: "14px", fontWeight: "700" }}>POLICIES</a>
      
      <div className="mega-menu2">
        {/* Column 1 */}
        <div>
          <div className="menu-title">Policies</div>
          <Link to="/Policies/Privacy-Policy" className="menu-link">Privacy Policy</Link>
          <Link to="/Policies/Terms-Conditions" className="menu-link">Terms and Condition</Link>
          <Link to="/Policies/Refund-Cancellation" className="menu-link">Refund & Cancellation Policy</Link>
        </div>
      </div>
    </div>

    {/* Rest of Nav Items */}
    <Link 
  to="/careers" 
  style={{ 
    color: scrolled ? "#475569" : "#ffffff", 
    textDecoration: "none", 
    fontSize: "14px", 
    fontWeight: "700" 
  }}
>
  CAREERS
</Link>

    <Link to="/contact-us" style={{ textDecoration: 'none' }}>
  <button 
    className="btn-main" 
    style={{ 
      background: "#3b82f6", 
      color: "white", 
      border: "none", 
      padding: "12px 28px", 
      fontSize: "13px", 
      fontWeight: "900", 
      cursor: "pointer", 
      clipPath: "polygon(10% 0, 100% 0, 90% 100%, 0% 100%)",
      display: "block" 
    }}
  >
    Contact Us ↗
  </button>
</Link>
  </div>
</nav>

{/* 2. HERO SECTION WITH VIDEO BACKGROUND */}
      <section style={{ 
        height: "100vh", 
        display: "flex", 
        alignItems: "center", 
        padding: "0 10%", 
        position: "relative", 
        overflow: "hidden",
        backgroundColor: "#020617" // Fallback color
      }}>
        {/* THE VIDEO ELEMENT */}
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transform: "translate(-50%, -50%)",
            zIndex: 0,
            opacity: 0.8 // Adjust this to make the video darker or lighter
          }}
        >
          <source src="/hero-bg.mp4" type="video/mp4" />
        </video>

        {/* OVERLAYS FOR DEPTH */}
        <div style={{ 
          position: "absolute", 
          inset: 0, 
          background: "radial-gradient(circle at 15% 50%, rgba(2, 6, 23, 0.8) 0%, rgba(2, 6, 23, 0.4) 100%)",
          zIndex: 1 
        }}></div>
        
        <div style={{ 
          position: "absolute", 
          inset: 0, 
          backgroundImage: "radial-gradient(#3b82f6 1px, transparent 1px)", 
          backgroundSize: "40px 40px", 
          opacity: 0.1,
          zIndex: 1 
        }}></div>
        {/* PROMICON EXACT LOGO SILHOUETTE - RIGHT SIDE */}
<div style={{
  position: "absolute",
  top: "50%",
  right: "-5%", 
  transform: "translateY(-50%)",
  width: "50%", 
  height: "80%",
  pointerEvents: "none",
  zIndex: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  opacity: 0.7
}}>
 
</div>
        {/* TEXT CONTENT */}
        <div style={{ position: "relative", zIndex: 2 }}>
            <span className="section-label"></span>
            <h1 style={{ 
              fontSize: "clamp(32px, 5vw, 55px)", 
              fontWeight: "900", 
              margin: 0, 
              lineHeight: 1.00, 
              letterSpacing: "-2px",
              textShadow: "0 10px 30px rgba(0,0,0,0.5)" 
            }}>
               Re-Engineering Ecommerce<br/><span className="accent">and Enterprise Growth.</span>
            </h1>
            <p style={{ maxWidth: "600px", opacity: 0.8, fontSize: "18px", marginTop: "30px", lineHeight: "1.6" }}>
                Scaling Marketplace Success with Enterprise Vision. Authorized SPN expertise for Amazon & Flipkart, Architecting future-ready frameworks for Microsoft AI and SAP ecosystems.
            </p>
            <div style={{ marginTop: "50px", display: "flex", gap: "20px" }}>
                <Link to="/contact-us"style={{ textDecoration: 'none' }}>
  <button className="btn-main">
    Explore Now ➜
  </button>
</Link>
                
            </div>
        </div>
      </section>
      
      
      <section style={{
  width: "100%",
  backgroundColor: "#e2e8f0", 
  /* Reduced vertical padding, removed horizontal % padding */
  padding: "40px 0",
  color: "#111827",
  borderBottom: "1px solid #e5e7eb",
  overflow: "hidden" /* Prevents any internal element from pushing the page wide */
}}>
  {/* The Container: This manages the "Going out of screen" issue */}
  <div style={{ 
    maxWidth: "1200px", 
    margin: "0 auto", 
    padding: "0 20px", /* Standard mobile safety padding */
    boxSizing: "border-box"
  }}>
    
    <div style={{ 
      width: "50px", 
      height: "4px", 
      backgroundimage: "#3b82f6", 
      marginBottom: "25px" 
    }}></div>

    <h2 style={{
      fontSize: "clamp(28px, 4vw, 42px)",
      fontWeight: "800",
      marginBottom: "40px",
      color: "#0f172a",
      letterSpacing: "-1px",
      lineHeight: "1.2"
    }}>
      What Sets Us Apart<span style={{color: "#3b82f6"}}>.</span>
    </h2>

    <div style={{   
      display: "grid", 
      /* Using 1fr 1fr with a gap ensures the right side doesn't feel 'empty' */
      gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", 
      gap: "40px",
      alignItems: "start" 
    }}>
      
      <div>
        <p style={{ 
          fontSize: "19px", 
          color: "#4e607d", 
          fontWeight: "500", 
          lineHeight: "1.7"
        }}>
          <strong>Promicon</strong> is a premier marketplace growth integrator. We specialize in 
          helping manufacturers reimagine their digital operating models, bridging the gap 
          between legacy infrastructure and modern digital demand.
        </p>
      </div>

      <div>
        <p style={{ 
          fontSize: "18px", 
          color: "#4b5563", 
          lineHeight: "1.8",
          opacity: 0.9 
        }}>
          We bridge the gap between manufacturer capabilities and the rigorous technical demands of <strong>Amazon and Flipkart</strong>. By optimizing every aspect, we ensure your brand achieves consistent, scalable, and profitable growth across India’s leading e-commerce ecosystems.
        </p>
      </div>

    </div>
  </div>
</section>
  <section style={{
  width: "100%",
  backgroundColor: "#182034",
  color: "white",
  padding: "10px 0 0 0" 
}}>
  <section style={{
  width: "100%",
  backgroundColor: "#182034", /* Matching your dark theme */
  padding: "20px 0 0 0", /* Bottom padding is 0 because grid is full-width */
  color: "white"
}}>
  {/* Header Section */}
  <div style={{ paddingLeft: "5%", marginBottom: "45px" }}>
    <h4 style={{ color: "#dadee6", fontSize: "14px", fontWeight: "1000", letterSpacing: "3px", textTransform: "uppercase" }}>
      SERVICES
    </h4>
    <h2 style={{ 
      fontSize: "clamp(30px, 3vw, 50px)", 
      fontWeight: "800", 
      marginTop: "10px",
      letterSpacing: "-1px"
    }}>
      Performance<span style={{color: "rgb(83, 119, 238)"}}>.</span> Scalability<span style={{color: "rgba(87, 115, 255, 0.92)"}}>.</span> Dominance<span style={{color: "rgb(84, 110, 239)"}}>.</span>
    </h2>
  </div>

  {/* FULL WIDTH SQUARE GRID - NOW 3 COLUMNS */}
  <div style={{
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", /* Changed to 3 for 2x3 layout */
    width: "100%",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)"
  }}>
    <style>{`
      .yash-card {
        position: relative;
        overflow: hidden;
        aspect-ratio: 1 / .90; 
        border-right: 1px solid rgba(255, 255, 255, 0.1);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 12% 10%;
      }
      .yash-img {
        position: absolute;
        top: 0; left: 0; width: 100%; height: 100%;
        object-fit: cover;
        z-index: 1;
        opacity: 0.6;
        transition: 0.6s cubic-bezier(0.33, 1, 0.68, 1);
      }
      .yash-card:hover .yash-img {
        opacity: 1;
        transform: scale(1.08);
      }
      .yash-gradient {
        position: absolute;
        top: 0; left: 0; width: 100%; height: 100%;
        background: linear-gradient(to bottom, rgba(7, 9, 14, 0.1) 0%, rgba(7, 9, 14, 0.95) 85%);
        z-index: 2;
      }
      .yash-text-content {
        position: relative;
        z-index: 3;
      }
      .yash-arrow-icon {
        position: absolute;
        bottom: 12%;
        right: 10%;
        font-size: 24px;
        color: white;
        z-index: 4;
        transition: 0.3s;
      }
      .yash-card:hover .yash-arrow-icon {
        color: #3b82f6;
        transform: translate(5px, -5px);
      }
    `}</style>

    {[
      { 
        title: "Ecommerce Marketplace Management", 
        path: "/HomepageServices/Ecommerce-Management",
        desc: "Power your Amazon and Flipkart accounts with robust account health. Streamline operations for consistent performance and fewer escalations. Manage every marketplace task smoothly.", 
        img: "MGMT2.jpg" 
      },
      { 
        title: "Product Listing & Catalog Strategy",
        path: "/HomepageServices/Listing-Catalog Strategy", 
        desc: "Elevate Amazon and Flipkart digital shelf presence using optimized catalogs and content. Ensure search visibility, consistency, and higher conversion across marketplaces.", 
        img: "Listing2.jpg" 
      },
      { 
        title: "Amazon PPC & Flipkart Ads Management",
        path: "/HomepageServices/Ads-Management", 
        desc: "Drive profitable growth with strategic Amazon PPC and Flipkart Ads execution. Improve ACoS efficiency and CTR through continuous keyword, bid, and placement optimization.", 
        img: "ads3.jpg" 
      },
      { 
        title: "Aplus Content",
        path: "/HomepageServices/Aplus-Infographics", 
        desc: "Design high-impact A+ Content and infographics that build trust and drive conversions.Create structured, on-brand storefronts to strengthen visibility across Amazon and Flipkart.", 
        img: "aplus3.jpg" 
      },
      { 
        title: "Enterprise Systems & Processes",
        path: "/HomepageServices/Enterprise-Systems", 
        desc: "Support core enterprise systems and finance-led business processes. Enable stability, control, and readiness across evolving enterprise environments.", 
        img: "SAPENT.jpg" 
      },
      { 
        title: "Productivity Data and Automation tools",
        path: "/HomepageServices/Productivity-tools", 
        desc: "Leverage modern productivity, data, and automation tools to simplify operations. Improve visibility, efficiency, and decision-making across business workflows.", 
        img: "Microsoft.jpg" 
      }
    ].map((item, i) => (
  <Link 
    key={i} 
    to={item.path} 
    className="yash-card" 
    style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
  >
    <img src={item.img} className="yash-img" alt={item.title} />
    <div className="yash-gradient"></div>
    
    <div className="yash-text-content">
      <h3 style={{ fontSize: "clamp(18px, 2vw, 24px)", fontWeight: "700", marginBottom: "12px" }}>
        {item.title}
      </h3>
      <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.7)", lineHeight: "1.5", maxWidth: "90%" }}>
        {item.desc}
      </p>
    </div>
    
    <div className="yash-arrow-icon">↗</div>
  </Link>
    ))}
  </div>

</section>
  {/* Section Header */}
  <section style={{
  width: "100%",
  backgroundColor: "#e2e8f0", /* Solid Grey Background */
  padding: "20px 0 30px 0",
  color: "#0f172a"
}}>
 
  <div style={{ maxWidth: "1350px", margin: "0 auto", padding: "0 5%" }}>
    
    {/* SECTION HEADER */}
    <div style={{ marginBottom: "40px" }}>
      <h4 style={{ color: "#323435", fontSize: "14px", fontWeight: "1000", letterSpacing: "4px", marginBottom: "12px" }}>
        PARTNERS
      </h4>
      <h2 style={{ fontSize: "48px", fontWeight: "800", letterSpacing: "-1.5px", margin:"0" }}>
        Strategic <span style={{ color: "#3b82f6" }}>Alliances. </span>
      </h2>
    </div>

    {/* DARK REVEAL GRID - 6 BOXES */}
    <div style={{ 
      display: "grid", 
      gridTemplateColumns: "repeat(3, 1fr)", 
      gap: "25px"   
    }}>
      
    </div>
  </div>
  <style>{`
  .alliances-final-section {
    background-color: #e2e8f0; /* Soft premium grey for contrast */
    padding: 5px 0;
    width: 100%;
    font-family: 'Inter', system-ui, sans-serif;
  }

  .alliances-container {
    max-width: 1200px; /* Limits box width for a tighter look */
    margin: 0 auto;
    padding: 0 80px;
  }

  .alliances-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); 
    gap: 50px;
  }

  .alliance-card {
    position: relative;
    aspect-ratio: 16 / 9; /* Sleeker letterbox ratio */ 
    background: #0b1121;
    cursor: pointer;
    border-radius: 24px; /* Perfectly circular bento edges */
    overflow: hidden;
    transform: translateZ(0);
    border: 0px solid rgba(255, 255, 255, 0.05);
  }

  .alliance-image {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 2;
    border-radius: inherit; 
    transition: filter 0.6s cubic-bezier(0.2, 1, 0.3, 1), opacity 0.6s ease;
    will-change: filter; /* Pre-optimizes browser for the blur */
  }

  .alliance-card:hover .alliance-image {
    filter: blur(8px) brightness(0.8); /* Deep blur for text legibility */
    opacity: 0.8;
  }

  .alliance-overlay {
    position: relative;
    z-index: 3;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centers content in the new rectangular height */
    padding: 30px;
    opacity: 0; 
    transform: translateY(15px);
    transition: opacity 0.4s ease, transform 0.4s cubic-bezier(0.2, 1, 0.3, 1);
  }

  .alliance-card:hover .alliance-overlay {
    opacity: 1;
    transform: translateY(0);
  }

  .alliance-name {
    color: #ffffff;
    font-size: 22px; /* Balanced for the rectangular size */
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 10px;
  }

  .alliance-desc {
    color: #cbd5e1;
    font-size: 14px;
    line-height: 1.5;
    max-width: 95%;
  }

  .expand-link {
    margin-top: auto;
    color: #ffffff;
    font-weight: 600;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end; /* Bottom right as per Accenture style */
    gap: 6px;
  }
`}</style>

<section className="alliances-final-section">
  <div className="alliances-container">
    <div className="alliances-grid">
      {/* 6 Square Alliances */}
      {[
        { name: "Amazon", img: "/AMZCARD2.jpeg", path: "/partners/amazon-alliance"},
        { name: "Flipkart", img: "/Fk234.jpeg", path: "/partners/flipkart-alliance"},
        { name: "Meesho", img: "/Meesho54.jpeg", path: "/partners/meesho-alliance"},
        { name: "SAP", img: "/SAPCARD1.jpg", path: "/partners/sap-alliance"},
        { name: "Microsoft", img: "/Micro23.jpg", path: "/partners/microsoft-alliance"},
        { name: "Meta", img: "/METACARD1.jpg", path: "/partners/meta-alliance"},
      ].map((partner, index) => (
  <Link 
    to={partner.path} 
    key={index} 
    className="alliance-card" 
    style={{ textDecoration: 'none', color: 'inherit' }}
  >
    <img src={partner.img} className="alliance-image" alt={partner.name} />
    <div className="alliance-overlay">
      <span className="alliance-tag">{partner.tag}</span>
      <h3 className="alliance-name">{partner.name}</h3>
      <p className="alliance-desc">
        Learn More >  
      </p>
      <div className="expand-link">Expand <span>›</span></div>
    </div>
  </Link>
      ))}
    </div>
  </div>
</section>
</section>
  <section style={{
  width: "100%",
  backgroundColor: "#f1f5f9", /* Matches your grey background theme */
  padding: "40px 0 50px 0",
  overflow: "hidden", /* Hides the logos as they scroll off-screen */
  position: "relative"
}}>
  {/* Fading Edge Overlays: Makes the logos "emerge" from the sides */}
  <div style={{
    position: "absolute",
    top: 0, left: 0, bottom: 0, width: "150px",
    background: "linear-gradient(to right, #f1f5f9, transparent)",
    zIndex: 2, pointerEvents: "none"
  }}></div>
  <div style={{
    position: "absolute",
    top: 0, right: 0, bottom: 0, width: "150px",
    background: "linear-gradient(to left, #f1f5f9, transparent)",
    zIndex: 2, pointerEvents: "none"
  }}></div>

  <div style={{ maxWidth: "1350px", margin: "0 auto", padding: "0 5%", textAlign: "center", marginBottom: "25px" }}>
    <h4 style={{ color: "#64748b", fontSize: "16px", fontWeight: "900", letterSpacing: "3px", textTransform: "uppercase" }}>
      Powering Global Brands
    </h4>
  </div>

  {/* THE MARQUEE CONTAINER */}
  <div className="marquee-container">
    <style>{`
  :root {
    --marquee-height: 80px;   /* Controlled height for a sleeker look */
    --logo-gap: 80px;         /* Tightened gap for better flow */
    --scroll-speed: 40s;      /* Smooth pacing */
  }

  .marquee-section {
    width: 100%;
    background-color: #f8fafc; /* Very light grey/white */
    padding: 40px 0;           /* Reduced padding: 40px top and bottom */
    overflow: hidden;
    position: relative;
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
  }

  .marquee-container {
    display: flex;
    width: 100%;
    overflow: hidden;
    cursor: pointer;
    /* Soft edge fades so logos don't 'pop' in at the edges */
    mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
    -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
  }

  /* HOVER TO STOP */
  .marquee-container:hover .marquee-content {
    animation-play-state: paused !important;
  }

  .marquee-content {
    display: flex;
    align-items: center;
    gap: var(--logo-gap);
    flex-shrink: 0;
    /* Ensures the gap is added to the end for a perfect loop */
    padding-right: var(--logo-gap); 
    animation: scroll-marquee var(--scroll-speed) linear infinite;
  }

  .logo-item {
    flex-shrink: 0;
    height: var(--marquee-height);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    /* No grayscale filter here - logos stay colorful */
  }

  .logo-item:hover {
    transform: scale(1.15); /* Slight pop when you hover over a specific logo */
  }

  .logo-item img {
    height: 100%;
    width: auto;      /* Maintains aspect ratio */
    max-width: 200px; /* Prevents long logos from dominating */
    object-fit: contain;
    /* Forces the browser to render the image sharply */
    image-rendering: -webkit-optimize-contrast; 
  }

  @keyframes scroll-marquee {
    from { transform: translateX(0); }
    to { transform: translateX(-100%); }
  }
`}</style>

<section className="marquee-section">
  <div className="marquee-container">
    {/* SET 1 */}
    <div className="marquee-content">
      <div className="logo-item"><img src="/amazon.png" alt="Amazon" /></div>
      <div className="logo-item"><img src="/flipkart.png" alt="Flipkart" /></div>
      <div className="logo-item"><img src="/tata.png" alt="Tata" /></div>
      <div className="logo-item"><img src="/samsung.png" alt="Samsung" /></div>
      <div className="logo-item"><img src="/meesho.png" alt="Meesho" /></div>
      <div className="logo-item"><img src="/nykaa.png" alt="Nykaa" /></div>
      {/* Add any other logos here */}
    </div>

    {/* SET 2 (Identical Copy for Infinite Loop) */}
    <div className="marquee-content" aria-hidden="true">
      <div className="logo-item"><img src="/amazon.png" alt="Amazon" /></div>
      <div className="logo-item"><img src="/flipkart.png" alt="Flipkart" /></div>
      <div className="logo-item"><img src="/tata.png" alt="Tata" /></div>
      <div className="logo-item"><img src="/samsung.png" alt="Samsung" /></div>
      <div className="logo-item"><img src="/meesho.png" alt="Meesho" /></div>
      <div className="logo-item"><img src="/nykaa.png" alt="Nykaa" /></div>
    </div>
  </div>
</section>

    {/* First set of logos */}
    <div className="marquee-content">
      <div className="logo-item"><img src="/Jolochip.jpeg" alt="Jolochip" /></div>
      <div className="logo-item"><img src="/Jetveli.png" alt="Jetveli" /></div>
      <div className="logo-item"><img src="/Kirva Organics .png" alt="Kirva" /></div>
      <div className="logo-item"><img src="/Joy Juncture .JPEG" alt="JOYJUNCTRE" /></div>
      <div className="logo-item"><img src="/Niki .png" alt="Niki" /></div>
      <div className="logo-item"><img src="/Abode .png" alt="Abode" /></div>
      <div className="logo-item"><img src="/Future Roots .png" alt="Futureroots" /></div>
      <div className="logo-item"><img src="/Bare Elixir .png" alt="BareElixir" /></div>
      <div className="logo-item"><img src="/Aakichi .png" alt="Aakichi" /></div>
      <div className="logo-item"><img src="/THG.png" alt="THG" /></div>
      <div className="logo-item"><img src="/Blue Squad .png" alt="Bluesqaud" /></div>
      <div className="logo-item"><img src="/Utensils Master .png" alt="Utensil" /></div>
      <div className="logo-item"><img src="/Infanto.png" alt="Infanto" /></div>
    </div>

    {/* Duplicate set for seamless looping */}
    <div className="marquee-content" aria-hidden="true">
      <div className="logo-item"><img src="/Jolochip.jpeg" alt="Jolochip" /></div>
      <div className="logo-item"><img src="/Jetveli.png" alt="Jetveli" /></div>
      <div className="logo-item"><img src="/Kirva Organics .png" alt="Kirva" /></div>
      <div className="logo-item"><img src="/Joy Juncture .JPEG" alt="JOYJUNCTRE" /></div>
      <div className="logo-item"><img src="/Niki .png" alt="Niki" /></div>
      <div className="logo-item"><img src="/Abode .png" alt="Abode" /></div>
      <div className="logo-item"><img src="/Future Roots .png" alt="Futureroots" /></div>
      <div className="logo-item"><img src="/Bare Elixir .png" alt="BareElixir" /></div>
      <div className="logo-item"><img src="/Aakichi .png" alt="Aakichi" /></div>
      <div className="logo-item"><img src="/THG.png" alt="THG" /></div>
      <div className="logo-item"><img src="/Blue Squad .png" alt="Bluesqaud" /></div>
      <div className="logo-item"><img src="/Utensils Master .png" alt="Utensil" /></div>
      <div className="logo-item"><img src="/Infanto.png" alt="Infanto" /></div>
    </div>
  </div>
</section>
  
  {/* TEXT-BASED PARTNER GRID (No Logos) */}
  <div style={{ 
    maxWidth: "1200px", 
    margin: "0 auto", 
    padding: "0 20%", 
    display: "grid", 
    gridTemplateColumns: "1fr 1.5fr", /* Strict proportional split */
    gap: "0px", /* Removing gap to control spacing via padding for better alignment */
    alignItems: "stretch"
  }}>
  </div>

<style>{`
  .blog-section {
    background-color: #182034;
    padding: 40px 5%;
    position: relative;
  }

  .blog-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .blog-title {
    font-size: clamp(30px, 3vw, 50px);
    font-weight: 800;
    color: #ffffff;
    margin-top: 5px;
  }

  .blog-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .blog-card {
    position: relative; /* Required for the glow effect */
    background: #182034;
    border: 1px solid rgba(255, 255, 255, 0.43);
    border-radius: 9px;
    padding: 20px;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    /* Smooth return transition */
    transition: all 0.4s cubic-bezier(0.2, 1, 0.3, 1);
    overflow: hidden;
  }

  /* RESTORED: The Premium Glow Border on Hover */
  .blog-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(248, 248, 248, 0.84) 0%, transparent 50%);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: 0;
  }

  /* RESTORED: Hover Lift and Glow Visibility */
  .blog-card:hover {
    transform: translateY(-8px);
    border-color: rgba(255, 255, 255, 0);
    background: #182034;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  }

  .blog-card:hover::before {
    opacity: 1;
  }

  .blog-image-wrap {
    width: 100%;
    height: 160px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 15px;
    z-index: 1; /* Keeps image above the background glow */
  }

  .blog-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }

  /* RESTORED: Image Zoom on Hover */
  .blog-card:hover .blog-image {
    transform: scale(1.1);
  }

  .blog-card h3 {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.3;
    margin-bottom: 15px;
    z-index: 1;
    transition: color 0.3s ease;
  }

  /* RESTORED: Title Color Change on Hover */
  .blog-card:hover h3 {
    color: #f9fbff;
  }

  .blog-meta {
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
  }

  .time-text {
    color: #4b5563;
    font-size: 11px;
    font-weight: 700;
  }
`}</style>

<section className="blog-section">
  <div className="blog-container">
    <header className="blog-header">
      <h4 style={{ color: "#e1e3e3", fontSize: "14px", fontWeight: "1000", letterSpacing: "4px", marginBottom: "12px" }}>
        INSIGHTS
      </h4>
      <h2 style={{ 
      fontSize: "clamp(30px, 3vw, 50px)", 
      fontWeight: "800", 
      marginTop: "10px",
      letterSpacing: "-1px"
    }}>
      Promicon<span style={{color: "rgb(83, 119, 238)"}}>.</span> Vision<span style={{color: "rgba(87, 115, 255, 0.92)"}}>.</span>
    </h2>
    </header>

    <div className="blog-grid">
      {/* CARD 1 */}
      <a href="#" className="blog-card">
        <div className="blog-image-wrap">
          <img src="BLOG1.jpeg" className="blog-image" alt="Web3" />
        </div>
        <div className="blog-category" style={{color: '#3b82f6', fontSize: '12px', fontWeight: '800', marginBottom: '5px'}}></div>
        <h3>1. Why Most Amazon Sellers Fail And How to Fix It</h3>
        <div className="blog-meta">
          <div className="author-tag">
            <div className="author-dot"></div>
            <span style={{color: '#eee', fontSize: '14px'}}>Ecommerce</span>
          </div>
          <span className="time-text">4 MIN</span>
        </div>
      </a>

      {/* CARD 2 */}
      <a href="#" className="blog-card">
        <div className="blog-image-wrap">
          <img src="MGMT.jpg" className="blog-image" alt="Design" />
        </div>
        <div className="blog-category" style={{color: '#3b82f6', fontSize: '12px', fontWeight: '800', marginBottom: '0px'}}></div>
        <h3>How Professional Marketplace Management Increases Sales by 3X</h3>
        <div className="blog-meta">
          <div className="author-tag">
            <div className="author-dot"></div>
            <span style={{color: '#eee', fontSize: '14px'}}>Ecommerce</span>
          </div>
          <span className="time-text">6 MIN</span>
        </div>
      </a>

      {/* CARD 3 */}
      <a href="#" className="blog-card">
        <div className="blog-image-wrap">
          <img src="BLOG3.JPEG" className="blog-image" alt="Future" />
        </div>
        <div className="blog-category" style={{color: '#3b82f6', fontSize: '12px', fontWeight: '800', marginBottom: '0px'}}></div>
        <h3>Operational Excellence Through Enterprise Systems: The Strategic Advantage of SAP & Microsoft</h3>
        <div className="blog-meta">
          <div className="author-tag">
            <div className="author-dot"></div>
            <span style={{color: '#eee', fontSize: '14px'}}>Enterprise</span>
          </div>
          <span className="time-text">5 MIN</span>
        </div>
      </a>
    </div>
  </div>
</section>

</section>
<section style={{
  width: "100%",
  backgroundColor: "#07090e",
  padding: "0px 0", /* Very tight vertical spacing */
  position: "relative"
}}>
  <div style={{
    maxWidth: "1350px",
    margin: "0 auto",
    height: "380px", /* Compact height */
    borderRadius: "24px",
    backgroundImage: "url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=1600')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    boxShadow: "0 20px 40px rgba(0,0,0,0.4)"
  }}>
    
    {/* THE DOCKED CONTENT CARD */}
    <div style={{
      backgroundColor: "white",
      padding: "40px 60px",
      borderRadius: "0 24px 24px 0", /* Docked to the left edge */
      maxWidth: "450px",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      zIndex: 2,
      position: "relative"
    }}>
      <h4 style={{ 
        color: "#3b82f6", 
        fontSize: "12px", 
        fontWeight: "700", 
        letterSpacing: "2px", 
        textTransform: "uppercase",
        marginBottom: "10px"
      }}>
        * CAREERS
      </h4>
      
      <h2 style={{ 
        color: "#0f172a", 
        fontSize: "34px", 
        fontWeight: "800", 
        lineHeight: "1.1",
        marginBottom: "15px",
        letterSpacing: "-1.5px"
      }}>
        Shape Your Future, Join Promicon.
      </h2>

      <p style={{ 
        color: "#475569", 
        fontSize: "15px", 
        lineHeight: "1.5", 
        marginBottom: "30px"
      }}>
        Work with global marketplace experts to scale the world's most ambitious brands.
      </p>

      {/* THE BUTTON: Proper <a> element with YASH styling */}
      <Link 
  to="/careers" 
  style={{
    display: "inline-block",
    width: "fit-content",
    padding: "12px 35px",
    border: "1.5px solid #0f172a",
    color: "#0f172a",
    textDecoration: "none",
    fontWeight: "700",
    fontSize: "14px",
    borderRadius: "50px", /* Pill shape */
    transition: "all 0.3s ease",
    textAlign: "center"
  }}
  onMouseOver={(e) => {
    e.currentTarget.style.backgroundColor = "#0f172a";
    e.currentTarget.style.color = "white";
  }}
  onMouseOut={(e) => {
    e.currentTarget.style.backgroundColor = "transparent";
    e.currentTarget.style.color = "#0f172a";
  }}
>
  Explore now
</Link>
    </div>

    {/* OVERLAY: Adds depth to the background image */}
    <div style={{
      position: "absolute",
      top: 0, left: 0, width: "100%", height: "100%",
      background: "linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.2) 100%)",
      zIndex: 1
    }}></div>
  </div>
</section>    

<style>{`
  .ultimate-footer {
    background-color: #000;
    color: #fff;
    padding: 60px 0 30px 0;
    font-family: 'Inter', sans-serif;
    position: relative;
    overflow: hidden;
  }

  /* KINETIC BACKGROUND - LOCKED EFFECT */
  .kinetic-canvas {
    position: absolute;
    top: 0;
    right: -5%;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    opacity: 0.18;
    pointer-events: none;
    mask-image: linear-gradient(to right, transparent, black 40%);
  }

  .kinetic-line {
    font-size: 110px;
    font-weight: 900;
    line-height: 0.8;
    white-space: nowrap;
    display: flex;
  }

  .line-right { animation: scrollRight 30s linear infinite; }
  .line-left { animation: scrollLeft 35s linear infinite; }

  @keyframes scrollRight { 0% { transform: translateX(-50%); } 100% { transform: translateX(0%); } }
  @keyframes scrollLeft { 0% { transform: translateX(0%); } 100% { transform: translateX(-50%); } }

  .outline-text { -webkit-text-stroke: 1.5px #fff; color: transparent; padding-right: 40px; }
  .solid-text { padding-right: 40px; }

  /* RESTRUCTURED NAVIGATION */
  .footer-inner {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 60px;
    position: relative;
    z-index: 10;
  }

  .footer-top-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 60px;
  }

  .footer-brand h2 {
    font-size: 42px;
    font-weight: 800;
    letter-spacing: -2px;
    margin: 0;
  }

  .footer-brand span { color: #3b82f6; }

  .footer-nav-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* Balanced columns */
    gap: 80px;
  }

  .nav-col h4 {
    font-size: 13px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #3b82f6; /* Brand Blue */
    margin-bottom: 25px;
  }

  .nav-link {
    color: #fff;
    text-decoration: none;
    font-size: 15px;
    font-weight: 400;
    display: block;
    margin-bottom: 12px;
    opacity: 0.7;
    transition: all 0.3s ease;
  }

  .nav-link:hover {
    opacity: 1;
    transform: translateX(5px);
  }

  /* ENHANCED SOCIALS & BOTTOM */
  .footer-bottom {
    max-width: 1400px;
    margin: 40px auto 0;
    padding: 30px 60px 0;
    border-top: 1px solid rgba(255,255,255,0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .copyright { color: #666; font-size: 13px; }

  .social-wrapper {
    display: flex;
    gap: 20px;
  }

  .social-icon {
    width: 50px;
    height: 50px;
    background: rgba(255,255,255,0.05);
    border-radius: 10px; /* Bento rounding */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .social-icon:hover {
    background: #3b82f6;
    transform: translateY(-3px);
  }

  .social-icon svg {
    width: 32px;
    height: 32px;
    fill: #fff;
  }
`}</style>

<footer className="ultimate-footer">
  <div className="kinetic-canvas">
    <div className="kinetic-line line-right">
      <span className="outline-text">PROMICON</span><span className="solid-text">STRATEGY</span>
    </div>
    <div className="kinetic-line line-left">
      <span className="solid-text">ALLIANCE</span><span className="outline-text">CHANGE</span>
    </div>
  </div>

  <div className="footer-inner">
    <div className="footer-top-row">
      <div className="footer-brand">
        <h2>PROMICON<span>.</span></h2>
      </div>

      <div className="footer-nav-grid">
        <div className="nav-col">
          <h4>Company</h4>
          <Link to="/about-us" className="nav-link">About Us</Link>
          <Link to="/Careers" className="nav-link">Careers</Link>
          <Link to="/contact-us" className="nav-link">Contact Us</Link>
        </div>
        <div className="nav-col">
          <h4>Quick Links</h4>
          <Link to="/Policies/Privacy-Policy" className="nav-link">Privacy Statement</Link>
          <Link to="/Policies/Terms-Conditions" className="nav-link">Terms & Conditions</Link>
          <Link to="/Blogs" className="nav-link">Blogs</Link>
        </div>
        <div className="nav-col">
          <h4>Support</h4>
          <a href="#" className="nav-link">Sitemap</a>
          <a href="#" className="nav-link">Accessibility</a>
          <a href="#" className="nav-link">Preference Center</a>
        </div>
      </div>
    </div>
  </div>

  <div className="footer-bottom">
    <p className="copyright">© 2026 Promicon Technologies Private Limited. All rights reserved.</p>
    
    <div className="social-wrapper">
      <a href="https://www.linkedin.com/company/promicon-technologies-pvt-ltd" className="social-icon" aria-label="LinkedIn">
        <svg viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
      </a>
      <a href="https://x.com/promicon33863" className="social-icon" aria-label="Twitter">
        <svg viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
      </a>
      <a href="https://www.instagram.com/promicon.digital/" className="social-icon" aria-label="Instagram">
        <svg viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
      </a>
      <a href="https://wa.me/918109416662" className="social-icon" aria-label="Whatsapp">
        <svg viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.94 3.659 1.437 5.63 1.438h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
      </a>
    </div>
  </div>
</footer>
</div>
  );
};

export default Homepage;